export default "__VITE_ASSET__BKLRGJDe__"